//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["motionPart"],"CalculateGrueblerCount",{R_:{grueblerCount:''}},1,0],[["full_file_name"],"ExportRecurdynSdk",{},1,0],[["submechanism","name"],"RenameSubmechanism",{},2,0],[["sumbmechanism","solution"],"ReadDeactivatedStates",{},2,0],[["part"],"CreateAddSubmechanismBuilder",{R_:{builder:"Motion.AddSubmechanismBuilder"}},1,0],[["motionPart","obj"],"AddSuppressedObjectForAllSolutions",{},2,0],[["motionPart","obj"],"RemoveSuppressedObjectForAllSolutions",{},2,0],[["motionPart"],"ConvertTextBasedElements",{},1,0],[["minFacetEdgeLen","maxFacetEdgeLen","facetToSurfaceTolerance"],"SetAdamsStlParams",{},3,0],[["full_file_name","geoFormat"],"WriteAdamsGeometryFile",{},2,0],[["full_file_name"],"WriteAdamsAnlFile",{},1,0],[["full_file_name"],"WriteRdsdkAdmFile",{},1,0],[["motionPart","sourcePart"],"AddCADSourcePart",{},2,0],[["motionPart","deleteMotionObjects"],"RemoveCADSourcePart",{},2,0],[["motionPart"],"GetCADSourcePart",{R_:{sourcePart:"Part"}},1,0],[["motionPart"],"GetSolutionManager",{R_:{manager:"Motion.SolutionManager"}},1,0],[["bodies"],"CreateCsysOfPrincipalAxesOfInertia",{R_:{csys:"CoordinateSystem"}},1,0]],[]];
SPLM.Motion.MotionSimulation = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Motion.MotionSimulation";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.MotionSimulation.JaMotionMotionExportAdamsGeometryFormat = Object.freeze({
    "None" : "None", "Stl" : "Stl", "Parasolid" : "Parasolid"});

export default SPLM;